import { RfiType } from '../sdk';

type FieldMapping = {
  key: keyof RfiType;
  label: string;
  check: 'array' | 'truthy';
};

const FIELD_MAPPINGS: FieldMapping[] = [
  { key: 'projectReviewer', label: 'reviewer', check: 'array' },
  { key: 'projectCoordinator', label: 'coordinator', check: 'array' },
  { key: 'manager', label: 'manager', check: 'array' },
  { key: 'watchers', label: 'watchers', check: 'array' },
  { key: 'dueDateOffset', label: 'due_date_offset', check: 'truthy' },
  { key: 'locationDescription', label: 'location_details', check: 'truthy' },
  { key: 'costImpact', label: 'cost_impact', check: 'truthy' },
  { key: 'scheduleImpact', label: 'schedule_impact', check: 'truthy' },
  { key: 'priority', label: 'priority', check: 'truthy' },
  { key: 'discipline', label: 'discipline', check: 'array' },
  { key: 'category', label: 'category', check: 'array' },
  { key: 'reference', label: 'external_id', check: 'truthy' },
  { key: 'customAttributes', label: 'custom_fields', check: 'array' },
];

export const getRfiTypeFieldsInUse = (rfiType: RfiType) =>
  FIELD_MAPPINGS.reduce<string[]>((fieldsInUse, { key, label, check }) => {
    const value = rfiType[key];
    const isInUse = check === 'array' ? Array.isArray(value) && value.length > 0 : !!value;
    if (isInUse) {
      fieldsInUse.push(label);
    }
    return fieldsInUse;
  }, []);
